<template>
    <div class="app">
        <AppHeader v-if="$route.name != 'Maps Mobile'" />
        <div :class="[$route.name != 'Maps Mobile' ? 'app-body' : '']">
            <main class="main h-100">
                <router-view :key="$route.path"></router-view>
            </main>
        </div>
        <Footer
            v-if="['ListNews', 'DashBoard', 'Document', 'Feedback', 'About'].includes($route.name)"
        />
    </div>
</template>

<script>
import { Header as AppHeader } from '../components/';
import Footer from '@/components/Footer';

export default {
    name: 'full',
    components: {
        AppHeader,
        Footer
    }
};
</script>
